import { Component, OnInit } from "@angular/core";
import { take } from "rxjs/operators";
import { LoginService } from "src/app/domain/services/login.service";
import { UtilsService } from "src/app/domain/services/utils.service";
import { FileShared } from "./../../domain/models/file-shared.model";

@Component({
	selector: "app-login-layout",
	templateUrl: "./login-layout.component.html"
})
export class LoginLayoutComponent implements OnInit {
	version = localStorage.getItem("systemVersion");

	constructor(
		private loginService: LoginService,
		private utilsService: UtilsService
	) {}

	ngOnInit(): void {}

	public downloadPolicyPrivacy() {
		this.loginService
			.downloadPrivacyPolicyFile()
			.pipe(take(1))
			.toPromise()
			.then(response => {
				const fileSharedData = response?.data as FileShared;
				if (fileSharedData?.isSuccess) {
					this.utilsService.convertToPDF(fileSharedData);
				}
			});
	}

	public downloadFraudPrevention() {
		this.loginService
			.downloadFraudPreventionFile()
			.pipe(take(1))
			.toPromise()
			.then(response => {
				const fileSharedData = response?.data as FileShared;
				if (fileSharedData?.isSuccess) {
					this.utilsService.convertToPDF(fileSharedData);
				}
			});
	}
}
